import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import PerfectScrollbar from 'perfect-scrollbar';
import { AccessLevelModel } from 'src/app/models/access-level/access-level';
import { UserAccountTypeInnerModel } from 'src/app/models/user-account-type/user-account-type-inner';
import { AuthServiceService } from 'src/app/services/auth-service/auth-service.service';
import { CommonServiceService } from 'src/app/services/common-service/common-service.service';
import swal from 'sweetalert2';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type?: string;
    icontype?: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    type?: string;
    icontype?: string;
    children?: ChildrenItems[];
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'monitoring'
},
{
    path: '/page-management',
    title: 'Page Management',
    type: 'sub',
    icontype: 'dashboard',
    collapse: 'page-management',
    children: [
        {
            path: 'page', title: 'Page List',
            type: 'sub',
            children: [
                { path: 'page-create', title: 'Create Page' },
                { path: 'page-edit', title: 'Edit Page' }
            ]
        },
        {
            path: 'page-preview-list', title: 'Page Preview List',
            type: 'sub',
            children: [
                { path: 'page-edit', title: 'Edit Page Preview' }
            ]
        },
        {
            path: 'page-editor-list', title: 'Page Editor List',
            type: 'sub',
            children: [
                { path: '', title: '' },
            ]
        },
        {
            path: 'home-page', title: 'Home Page',
            type: 'sub',
            children: [
                { path: 'volunteer-group-image-create', title: 'Create Volunteer Group Image' },
                { path: 'volunteer-group-image-edit', title: 'Edit Volunteer Group Image' },
            ]
        },
        {
            path: 'past-committee-list', title: 'Committee List',
            type: 'sub',
            children: [
                { path: 'past-committee-create', title: 'Create Committee' },
                { path: 'past-committee-edit', title: 'Edit Committee' }
            ]
        },
        {
            path: 'committee-page-description', title: 'Committee Page Description',
            type: 'sub',
            children: [
                { path: '', title: '' },
            ]
        },
    ]
},
{
    path: '/activity-management',
    title: 'Activity Management',
    type: 'link',
    icontype: 'date_range',
    children: [
        { path: 'activity-create', title: 'Create Activity' },
        { path: 'activity-edit', title: 'Edit Activity' }
    ]
},
{
    path: '/banner-management',
    title: 'Banner Management',
    type: 'link',
    icontype: 'view_carousel',
    children: [
        { path: 'banner-create', title: 'Create Banner' },
        { path: 'banner-edit', title: 'Edit Banner' }
    ]
},
{
    path: '/nav-layer-management',
    title: 'Nav Layer Management',
    type: 'link',
    icontype: 'layers',
    children: [
        { path: 'nav-layer-create', title: 'Create Nav Layer' },
        { path: 'nav-layer-edit', title: 'Edit Nav Layer' }
    ]
},
{
    path: '/venue-management',
    title: 'Venue Management',
    type: 'sub',
    icontype: 'place',
    collapse: 'venue-management',
    children: [
        {
            path: 'venue-list', title: 'Venue List',
            type: 'sub',
            children: [
                { path: 'venue-create', title: 'Create Venue' },
                { path: 'venue-edit', title: 'Edit Venue' }
            ]
        },
        {
            path: 'venue-booking-list', title: 'Venue Booking List',
            type: 'sub',
            children: [
                { path: 'venue-booking-create', title: 'Create Venue Booking' },
                { path: 'venue-booking-edit', title: 'Edit Venue Booking' },
                { path: 'venue-booking-record', title: 'Venue Booking Record' }
            ]
        },
        {
            path: 'venue-booking-record', title: 'Venue Booking Record',
            type: 'sub',
            children: [

                { path: '', title: '' }
            ]
        },
    ]
},
{
    path: '/album-management',
    title: 'Album Management',
    type: 'sub',
    icontype: 'photo_library',
    collapse: 'album-management',
    children: [

        {
            path: 'album-list', title: 'Album List',
            type: 'sub',
            children: [
                { path: 'album-create', title: 'Create Album' },
                { path: 'album-edit', title: 'Edit Album' }
            ]
        },
        {
            path: 'album-item-list', title: 'Album Item List',
            type: 'sub',
            children: [
                { path: 'album-item-create', title: 'Create Album Item' },
                { path: 'album-item-edit', title: 'Edit Album Item' }
            ]
        },
    ]
},
{
    path: '/user-management',
    title: 'User Management',
    type: 'sub',
    icontype: 'group',
    collapse: 'user-management',
    children: [
        {
            path: 'user-account-list', title: 'User Account List',
            type: 'sub',
            children: [
                { path: 'user-account-create', title: 'Create User Account' },
                { path: 'user-account-edit', title: 'Edit User Account' }
            ]
        },
        {
            path: 'user-account-type-list', title: 'User Account Type List',
            type: 'sub',
            children: [
                { path: 'user-account-type-create', title: 'Create User Account Type' },
                { path: 'user-account-type-edit', title: 'Edit User Account Type' }
            ]
        },

    ]
},
{
    path: '/shorten-url-management',
    title: 'Shorten URL',
    type: 'link',
    icontype: 'link'
},
{
    path: '/donation-management',
    title: 'Donation Management',
    type: 'link',
    icontype: 'volunteer_activism',
    children: [
        { path: 'donation-edit', title: 'Edit Donation' }
    ]
},
{
    path: '/learning-management',
    title: 'Learning Management',
    type: 'sub',
    icontype: 'import_contacts',
    collapse: 'learning-management',
    children: [
        {
            path: 'dharma-hub-list', title: 'Dharma Hub List',
            type: 'sub',
            children: [
                { path: 'dharma-hub-create', title: 'Create Dharma Hub' },
                { path: 'dharma-hub-edit', title: 'Edit Dharma Hub' }
            ]
        },
        {
            path: 'video-podcast-list', title: 'Video Podcast List',
            type: 'sub',
            children: [
                { path: '', title: '' },
            ]
        },
        {
            path: 'video-podcast-category-list', title: 'Video Podcast Category List',
            type: 'sub',
            children: [
                { path: '', title: '' },
            ]
        },
    ]
},
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit, OnDestroy {
    public menuItems: any[];
    ps: any;
    private mutationObserver: MutationObserver;
    bodyClass: string = '';
    private resizeObserver: ResizeObserver;
    logoWidth: number;
    accessLevel: AccessLevelModel | null = null;

    userAccountType?: UserAccountTypeInnerModel;
    username?: string;
    constructor(private commonService: CommonServiceService, private elRef: ElementRef, private router: Router, private cdr: ChangeDetectorRef, private authService: AuthServiceService) {
    }

    ngAfterViewInit(): void {
        const sidebarElement = this.elRef.nativeElement.querySelector('.logo');
        if (sidebarElement) {
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    this.logoWidth = entry.contentRect.width;
                    // Notify Angular of the change
                    this.cdr.detectChanges();
                }
            });
            this.resizeObserver.observe(sidebarElement);
        } else {
            console.error('Sidebar element not found');
        }
    }


    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        this.fetchUserAccountDetails();

        // this.menuItems = ROUTES.filter(menuItem => menuItem);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }

        // Set up MutationObserver to observe changes to the body's class attribute
        this.mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const bodyClass = document.body.className;
                    this.bodyClass = bodyClass;
                }
            });
        });

        // Observe the body element for attribute changes
        this.mutationObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
        // Subscribe to the accessLevel$ observable 
        this.commonService.accessLevel$.subscribe(accessLevel => {
            this.accessLevel = accessLevel;
            // Filter the menu items based on the access level 
            this.menuItems = this.filterMenuItems(ROUTES, accessLevel);
        });
    }
    fetchUserAccountDetails() {
        const username = this.authService.getStoredUsername();
        const userAccountType = this.authService.getStoredUserAccountType();
        if (!username || !userAccountType) { return; }

        this.username = username;
        this.userAccountType = userAccountType;

    }

    hasAccess(path: string, accessLevel: AccessLevelModel): boolean {

        switch (path) {
            //link
            case '/activity-management': return accessLevel.activityView;
            case '/banner-management': return accessLevel.bannerView;
            case '/shorten-url-management': return accessLevel.shortUrlView;
            case '/nav-layer-management': return accessLevel.navLayerView;
            case '/donation-management': return accessLevel.donationView;
            //sub menu items
            case 'page': return accessLevel.navPageView;
            case 'page-preview-list': return accessLevel.navPageCreate;
            case 'page-editor-list': return accessLevel.navPageEditorView;
            case 'past-committee-list': return accessLevel.pastCommitteeView;
            case 'committee-page-description': return accessLevel.pastCommitteeView;
            case 'home-page': return accessLevel.buttonUrlView;
            case 'venue-list': return accessLevel.venueView;
            case 'venue-booking-list': return accessLevel.venueBookingView;
            case 'venue-booking-record': return accessLevel.venueBookingRecordView;
            case 'album-list': return accessLevel.navAlbumView;
            case 'album-item-list': return accessLevel.navAlbumItemView;
            case 'user-account-list': return accessLevel.userAccountView;
            case 'user-account-type-list': return accessLevel.userAccountTypeView;
            case 'dharma-hub-list': return accessLevel.dharmaHubView;
            case 'video-podcast-list': return accessLevel.videoPodcastView;
            case 'video-podcast-category-list': return accessLevel.videoPodcastCategoryView;

        }
    }

    filterMenuItems(menuItems: RouteInfo[], accessLevel: AccessLevelModel): RouteInfo[] {
        return menuItems.reduce((filtered: RouteInfo[], item: RouteInfo) => {
            if (item.type === 'sub' && item.icontype) {
                item.children = item.children.filter(child => this.hasAccess(child.path, accessLevel));
                if (item.children.length > 0) {
                    filtered.push(item);
                }
            }
            else if (item.type === 'link' && this.hasAccess(item.path, accessLevel)) {
                filtered.push(item);
            } else if (item.path === '/dashboard') {
                // Always include Dashboard 
                filtered.push(item);
            } return filtered;
        }, []);
    }

    ngOnDestroy(): void {

        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    expandOrCollapseMenu(id) {
        let parent = document.getElementById(id + "-p");
        let child = document.getElementById(id);
        parent.ariaExpanded = parent.ariaExpanded === "true" ? "false" : "true";

        child.style.height = child.style.height === "0px" || child.style.height === "" ? "100%" : "0";
    }


    isActive(childitem): boolean {
        const currentUrl = this.router.url;
        // Split the path to get the base part without ID
        const pathParts = currentUrl.split('/');
        if (pathParts.length > 1 && !isNaN(Number(pathParts[pathParts.length - 1]))) {
            // Remove the last part if it's a number (ID)
            pathParts.pop();
        }
        // Join the remaining parts to get the base path
        let basePath = pathParts[pathParts.length - 1]
        return childitem.path == basePath;
    }
    logout() {
        swal.fire({
            title: 'Logout',
            text: "Are you sure want to logout?",
            icon: 'question',
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger',
            },
            confirmButtonText: 'Confirm',
            buttonsStyling: false,
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.authService.logout();
            }
        });
    }
}
